import { render, staticRenderFns } from "./main-lawyer.vue?vue&type=template&id=3d8d534f&scoped=true"
import script from "./main-lawyer.vue?vue&type=script&lang=js"
export * from "./main-lawyer.vue?vue&type=script&lang=js"
import style0 from "./main-lawyer.vue?vue&type=style&index=0&id=3d8d534f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8d534f",
  null
  
)

export default component.exports